<div class="container">
  <div class="row dashboard">
    <div class="col-md-3 col-lg-2 dashboard-left">
      <div class="client-dd" *ngIf="false">
        <app-alight-drop-down [group]="rootScope.dashboardForm" [controlName]="'clientId'" [required]="false"
          description="clientName" [disable]="false" label="Select a Client*" [value]="'clientId'"
          [list]="customerService.clients" >
        </app-alight-drop-down>
      </div>
      <div class="client-dd" >
       

        <app-alight-smart-search-drop-down [group]="rootScope.dashboardForm" [controlName]="'clientNameDash'" [required]="false"
        description="clientName" [disable]="false" label="Select a Client*" [value]="'clientName'"
        [list]="customerService.clients" (change)="rootScope.getDashboardLeftNavData($event)"
        (change)="rootScope.getDashboardMyTodo($event)"
        (change)="appointmentsCardService.getDashboardMyAppointments($event)" (change)="getExpand($event)"
       
        >
      </app-alight-smart-search-drop-down>

      </div>
      <span class="section-divider"></span>
      <div class="dashboard-left-nav pos-relative">

        <app-loader *ngIf="rootScope.dashboardLeftNavLoader" [loaderType]="loaderType"
          [loaderMsg]="rootScope.dashboardLeftNavLoaderMsg"></app-loader>

        <section *ngIf="rootScope.dashboardLeftNavError" class="error-wrapper">
          <f-alert variant="error" class="error-without-heading">
            <p class="full-width">
              {{ errorMsg}}
            </p>
          </f-alert>
          <button mat-button color="primary" title="Refresh" class="btn-refresh hide">
            Refresh
            <i class="fa-solid fa-arrows-rotate"></i>
          </button>
        </section>

        <div class="accordion-tab" *ngFor="
            let menu of rootScope.dashboardNavBarData;
            let menuLastItem = last
          ">
          <mat-accordion>
            <mat-expansion-panel [expanded]="selectedMenu == menu?.id">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <i [ngClass]="menu.icon"></i> {{ menu.heading }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ul class="subLinks" *ngFor="let subMenu of menu?.subMenuList | sortBy : 'heading'">
                <li (click)="activateLeftMenu(menu, subMenu)" [ngClass]="{
                    active: rootScope.selectedSubMenu == subMenu.id
                  }">
                  <!-- <a href="javascript:void('0')">{{ subMenu.heading }}</a> -->
                  <button title="{{ subMenu.heading }}" class="navlinks">{{ subMenu.heading }}</button>
                </li>
              </ul>
            </mat-expansion-panel>
          </mat-accordion>
          <span *ngIf="!menuLastItem" class="section-divider"></span>
        </div>
      </div>

      <div>
      </div>
    </div>
    <div class="col-md-9 col-lg-10 pos-relative dashboard-right">
      <app-dashboard-filter class="dashboard-filter" *ngIf="rootScope.openFilterDialog"></app-dashboard-filter>
      <div class="row dashboard-body">
        <div class="col-md-12 col-lg-8 dashboard-top">
          <div class="main-data-card flex">
            <f-data-card class="data-card-1 ">
              <app-case-management-card></app-case-management-card>
            </f-data-card>
            <f-data-card class="data-card-2 ">
              <app-appointments-card></app-appointments-card>
            </f-data-card>
          </div>
          <div class="col-md-12">
            <app-agent-interaction-history></app-agent-interaction-history>
          </div>


        </div>

        <div class="col-md-12 col-lg-4 dashboard-bottom static-position">
          <div class="main-data-card">
            <f-data-card class="data-card-1 col-lg-12">
              <app-alis-registration></app-alis-registration>
            </f-data-card>
            <f-data-card class="data-card-2  col-lg-12 ">
              <!-- Connect to TBA GUI & eCS -->
              <app-tba-registration></app-tba-registration>
            </f-data-card>
          </div>
        </div>
      </div>
      <!-- <app-custom-dialog class="hide">
        <div id="content">
          <p>
            {{ inboundMsg }}
          </p>
          <div class="custom-overlay-footer">
            <f-button
              text="Got it"
              mat-dialog-close
              tabindex="1"
              buttonTitle="Got it"
              type="button"
              variant="progressive"
            ></f-button>
          </div>
        </div>
      </app-custom-dialog> -->

      <app-custom-dialog *ngIf="rootScope.customDialogData.displayCustomDialog" (actionOnClick)="buttonClick($event)">
      </app-custom-dialog>

    </div>
  </div>
</div>